module.exports = __webpack_public_path__ + "media/images/icon__dhi--rb-gray@2x-96d748b539a4fd6c9a3bf2d0bf4dd5e1.png";